export default __webpack_public_path__ + "static/media/0163.3bd807af.jpg";